import 'lazysizes';
import 'css/responsive/index.scss';
import 'js/shared/common/common.fn.js';
//import 'js/shared/common/simple_menu.js';